const dateValue = value => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatActivityDate = value => {
  const date = dateValue(value);
  if (!date) return "Unknown";
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "America/Chicago",
    timeZoneName: "short"
  }).format(date);
};

const needsTeamReview = user =>
  !!(
    user.teamActivity &&
    user.teamActivity.checked &&
    user.teamActivity.reviewRequired
  );

const historyLabel = activity => {
  if (!activity || !activity.checked) return "Unknown";
  if (!activity.teams.length) return "No current team";
  return activity.historyYears.length
    ? activity.historyYears.join(", ")
    : `No ${activity.reviewYears.join(" or ")} history`;
};

const latestTeamUpdate = user => {
  const teams =
    user.teamActivity && user.teamActivity.checked
      ? user.teamActivity.teams
      : [user.team];
  const dates = teams
    .filter(Boolean)
    .map(team => dateValue(team.updatedAt))
    .filter(Boolean);
  return dates.length
    ? new Date(Math.max(...dates.map(date => date.getTime()))).toISOString()
    : null;
};

const formatAdminUser = user => ({
  id: user.id,
  active: user.active,
  name: user.person
    ? `${user.person.firstName} ${user.person.lastName}`
    : "No Person Assigned",
  email: user.email,
  role: user.role,
  team:
    user.teamActivity && user.teamActivity.teams.length
      ? user.teamActivity.teams.map(team => team.name).join(", ")
      : (user.team && user.team.name) || "Unassigned",
  lastLoginAt: user.lastLoginAt || null,
  teamUpdatedAt: latestTeamUpdate(user),
  teamHistory: historyLabel(user.teamActivity),
  review: needsTeamReview(user)
    ? "Review: no history in the last two events"
    : ""
});

// Keep Unknown dates last in both ascending and descending order.
const compareActivityDates = (left, right, order = 1) => {
  const a = dateValue(left);
  const b = dateValue(right);
  if (!a || !b) return a ? -1 : b ? 1 : 0;
  return (a.getTime() - b.getTime()) * order;
};

export {
  formatActivityDate,
  formatAdminUser,
  needsTeamReview,
  compareActivityDates
};
